import React, { useEffect, useRef, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { WebService } from "../../Services/WebService";
import { Form, FormInputText, FormInputDropdown, FormInputFile } from "../Form";
import * as yup from "yup";
import { format } from "date-fns";
import { useDispatch } from "react-redux";
import { DateTime, Info } from "luxon";
import { extendOwn, findWhere, map, omit, sortBy, where } from "underscore";
import Col from "react-bootstrap/esm/Col";
import Row from "react-bootstrap/esm/Row";
import { StandardConst } from "../../Services/StandardConst";
import { Alert, AlertTitle, IconButton, Paper } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import { WSErrorAlert } from "../../Services/WSAlert";
import RichTextBox from "../../Services/RichTextBox";

const AddEditTimeSheet = (prop, ref) => {
  const [show, setShow] = useState(false);
  const [data, setData] = useState({ TimeSheet: {} });
  const [maxHour, setMaxHour] = useState(8);
  const [projectList, setProjectList] = useState([]);
  const [holiday, setHoliday] = useState([]);
  const [approvedLeave, setApprovedLeave] = useState([]);
  const [details, setDetails] = useState(null);
  const dispatch = useDispatch();
  const afterRender = useRef(false);
  const formRef = useRef();
  React.useImperativeHandle(ref, () => ({
    openModal: async (id, date, completedHours = 0) => {
      setShow(true);
      fetchProject(date);
      setMaxHour(24 - completedHours > 24 ? 24 : 24 - completedHours);
      if (id === 0){
        await fetchData(id, date);
      }else {
        setShow(false);
        await fetchData(id, date);
        setShow(true);
      }
    },
  }));

  const fetchData = async(id, date)=> {
    var data={};
    await Promise.all([
      WebService({
        dispatch,
        endPoint: `TimeSheet/FetchAll/${id || 0}/${date}`,
      }).then((r) => {
        setDetails(r.TimeSheet.Details);
        extendOwn(data, r)
      })
    ]);

    if ((data?.TimeSheet?.Date || "") !== "")
      data.TimeSheet.Date = format(
        new Date(data.TimeSheet.Date),
        "yyyy-MM-dd"
      );
    else {
      data.TimeSheet ??= {};
      data.TimeSheet.Date = date;
    }
    data.users = map(data?.users ?? [], (v) => {
      return {
        value: v.EmployeeId,
        text: v.FullName,
      };
    });

    setHoliday(data.holiday[0]);
    setApprovedLeave(data.approvedLeave[0]);

    setData(omit(data, "project"));
  }
  const handleClose = () => {
    setShow(false);
    setDetails(null);
    setData({ TimeSheet: {} })
  }
  const requiredMessage = "This is a required field";
  const schema = yup
    .object()
    .shape({
      TimeInHour: yup
        .number()
        .label("Time in Hour")
        .typeError(requiredMessage)
        .required(requiredMessage)
        .min(0.01)
        .when([], (_, passSchema) => passSchema.max(maxHour)),
      ProjectId: yup.string().trim().required(requiredMessage),
      TaskCategoryId: yup.string().trim().required(requiredMessage),
    })
    .required();
  const onSubmit = async (data) => {
    if(details === null || details === undefined) {
      WSErrorAlert("Error", "Please fill detail");
      return;
    }
    data.Details = details;
    if ((data.File?.size ?? 0) > 0)
      await WebService({
        endPoint: "upload/File",
        dispatch,
        body: data.File,
        isFile: true,
      }).then((res) => {
        data.Attachment = res.filename;
      });
    data = omit(data, "File");
    var endPoint = "TimeSheet/Submit";
    var method = "POST";
    if ((data.TimeSheetId || 0) != 0) {
      method = "PUT";
      endPoint += `/${data.TimeSheetId}`;
    }
    await WebService({ dispatch, endPoint, method, body: data });

    handleClose();
    prop.callBackEvent();
  };
  const fnDelete = async () => {
    await WebService({
      endPoint: `TimeSheet/${data.TimeSheet.TimeSheetId}`,
      method: "DELETE",
      dispatch,
    });
    handleClose();
    prop.callBackEvent();
  };

  const fetchProject = async (timesheetFillDate) => {
    setProjectList(
      await WebService({ dispatch, endPoint: `Project/byLoggedUser?TimeSheetFillDate=${format(new Date(timesheetFillDate), 'yyyy-MM-dd')}`, 
      requiredLoader:false
    }).then(
        (c) =>
          map(c ?? [], (m) => ({ value: m.ProjectId, text: m.ProjectName }))
      )
    );
  };
  useEffect(() => {
    if (
      (data?.TimeSheet?.ProjectId ?? 0) !== 0 &&
      where(data?.task ?? [], {
        ProjectId: data.TimeSheet.ProjectId,
        value: data.TimeSheet.TaskCategoryId,
      }).length < 1
    ) {
      Promise.all(
        formRef.current.fnReset((frmDt) => ({
          ...frmDt,
          TaskCategoryId: findWhere(data?.task ?? [], {
            ProjectId: data.TimeSheet.ProjectId,
          })?.value,
        }))
      );
    }
  }, [data?.TimeSheet?.ProjectId]);
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          {(data.TimeSheet.TimeSheetId || 0) === 0 ? "Add" : "Edit"} time entry
          for {DateTime.fromSQL(data.TimeSheet.Date).weekdayLong},{" "}
          {DateTime.fromSQL(data.TimeSheet.Date).toFormat("dd MMM")}
        </Modal.Title>
      </Modal.Header>
      <Form
        defaultValues={data.TimeSheet}
        onSubmit={onSubmit}
        validationSchema={schema}
        ref={formRef}
      >
        <>
          <Paper
            elevation={0}
            className={`${holiday.HolidayCount >= 1 ? "d-inline" : "d-none"}`}
          >
            <Alert severity="error" icon={<NotificationsActiveIcon />}>
              <AlertTitle>Holiday Notice</AlertTitle>
              This is an Holiday — <strong>{holiday.HolidayName}</strong>
            </Alert>
          </Paper>
          <Paper
            elevation={0}
            className={`${approvedLeave.Leaves >= 1 ? "d-inline" : "d-none"}`}
          >
            <Alert severity="info" icon={<NotificationsActiveIcon />}>
              <AlertTitle>Leave Notice</AlertTitle>
              You are on leave From{" "}
              <strong>{approvedLeave.LeaveFromDate} </strong> To{" "}
              <strong>{approvedLeave.LeaveToDate} </strong>
              as per leave records
            </Alert>
          </Paper>

          <Modal.Body className="p-3">
            <div className="container-fluid p-1">
              <div className="row">
                <FormInputText
                  label="Time"
                  name="TimeInHour"
                  type="number"
                  isRequired="true"
                />
              </div>
              <div className="row">
                <FormInputDropdown
                  name="ProjectId"
                  ddOpt={projectList}
                  label="Project"
                  isRequired="true"
                  setValue={(v) =>
                    setData((data) => ({
                      ...data,
                      TimeSheet: { ...data.TimeSheet, ProjectId: parseInt(v) },
                    }))
                  }
                ></FormInputDropdown>
              </div>
              <div className="row">
                <FormInputDropdown
                  name="TaskCategoryId"
                  ddOpt={where(data?.task ?? [], {
                    ProjectId: data?.TimeSheet?.ProjectId ?? 0,
                  })}
                  label="Task"
                  isRequired="true"
                  setValue={(v) =>
                    setData((data) => ({
                      ...data,
                      TimeSheet: {
                        ...data.TimeSheet,
                        TaskCategoryId: parseInt(v),
                      },
                    }))
                  }
                ></FormInputDropdown>
              </div>
              <div className="row mt-1 mb-1">
                <div className="col-md-12" style={{paddingLeft: "0px"}}>
                    <RichTextBox
                        value={details}
                        setValue={setDetails}
                    />
                </div>
                    
                {/* <FormInputText
                  label="Details"
                  name="Details"
                  as="textarea"
                  isRequired="true"
                /> */}
              </div>
              <div className="row mt-1">
                {(data?.TimeSheet?.Attachment ?? "") == "" && (
                  <FormInputFile name="File" type="file" label="Attachment" />
                )}
                {(data?.TimeSheet?.Attachment ?? "") != "" && (
                  <Row>
                    <Col md={5}>Attachment</Col>
                    <Col md={7}>
                      <a
                        href={`${StandardConst.apiBaseUrl}/uploads/${data?.TimeSheet?.Attachment}`}
                        target="_blank"
                      >
                        {data?.TimeSheet?.Attachment}
                      </a>
                      <IconButton
                        id="btn_RemoveAttachment"
                        size="small"
                        onClick={() => {
                          setData((data) => ({
                            ...data,
                            TimeSheet: { ...data.TimeSheet, Attachment: null },
                          }));
                          formRef.current.fnReset((formValues) => ({
                            ...formValues,
                            Attachment: null,
                          }));
                        }}
                        color="error"
                        aria-label="upload picture"
                        component="label"
                      >
                        <CancelIcon fontSize="small" />
                      </IconButton>
                    </Col>
                  </Row>
                )}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="outline-primary"
              id="btnSubmitTimeSheet"
              type="submit"
            >
              {(data.TimeSheet.TimeSheetId || 0) === 0
                ? "Submit"
                : "Save Changes"}
            </Button>
            {(data.TimeSheet.TimeSheetId || 0) === 0 ? (
              ""
            ) : (
              <Button
                variant="outline-danger"
                id="btnDeleteTimeSheetData"
                onClick={fnDelete}
              >
                Delete
              </Button>
            )}
          </Modal.Footer>
        </>
      </Form>
    </Modal>
  );
};

export default React.forwardRef(AddEditTimeSheet);
